import React from 'react';
import { Badge } from '@amzn/awsui-components-console';

export enum FeatureType {
	NEW = 'new',
	IMPROVEMENT = 'improvement',
	FIX = 'fix',
	COMING_SOON = 'coming-soon',
}

export enum FlashbarType {
	SUCCESS = 'success',
	ERROR = 'error',
	WARNING = 'warning',
	INFO = 'info',
}

export interface FlashbarItem {
	type: FlashbarType;
	header?: string;
	content: string;
	dismissible?: boolean;
	id: string;
	isGlobal?: boolean;
	isBlockingExecution?: boolean;
	expiresAt?: string;
	overrideBindle?: string;
	createdBy?: string;
	createdAt?: string;
}

interface FeatureTypeConfig {
	label: string;
	color: 'blue' | 'green' | 'grey' | 'red';
}

export const FEATURE_TYPE_CONFIG: Record<FeatureType, FeatureTypeConfig> = {
	[FeatureType.NEW]: {
		label: 'NEW',
		color: 'blue',
	},
	[FeatureType.IMPROVEMENT]: {
		label: 'IMPROVEMENT',
		color: 'green',
	},
	[FeatureType.FIX]: {
		label: 'FIX',
		color: 'red',
	},
	[FeatureType.COMING_SOON]: {
		label: 'COMING SOON',
		color: 'grey',
	},
};

export const getTypeBadge = (type: FeatureType) => {
	const config = FEATURE_TYPE_CONFIG[type];

	return <Badge color={config.color}>{config.label}</Badge>;
};
